module.exports = __webpack_public_path__ + "img/dotpoints-02.0e8cf049.svg";